import 'core-js';
import 'regenerator-runtime/runtime';
import React from 'react';
import { createRoot } from 'react-dom/client';

// Components
import App from './App';

// Context
import { GlobalStateProvider } from './context/global-context/provider';
import {
  globalStateReducer,
  initialGlobalState,
} from './context/global-context/reducer';

const container = document.getElementById('js-form-application');
const locale = container?.dataset.locale;
const debug = container?.dataset.debug === 'true' || false;
const formAlias = container?.dataset.formAlias;
const pageId = parseInt(container?.dataset?.pageId || '0');
const root = createRoot(container!);

if (root) {
  root.render(
    <GlobalStateProvider
      reducer={globalStateReducer}
      initialState={initialGlobalState}
    >
      <App
        language={locale}
        formAlias={formAlias}
        pageId={pageId}
        debug={debug}
      />
    </GlobalStateProvider>
  );
}
